module.exports = __webpack_public_path__ + "a57a376c91e3905f0bac705e4df1e14a.svg";